import { render, staticRenderFns } from "./CreateBatchPanel.vue?vue&type=template&id=2e34149b&scoped=true&"
import script from "./CreateBatchPanel.vue?vue&type=script&lang=js&"
export * from "./CreateBatchPanel.vue?vue&type=script&lang=js&"
import style0 from "./CreateBatchPanel.vue?vue&type=style&index=0&id=2e34149b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e34149b",
  null
  
)

export default component.exports